/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatusNotificationCommand } from '../../models/status-notification-command';

export interface ApiOcppOperationGetStatusNotificationForModuleGet$Plain$Params {
  chargerId?: string;
  connectorId?: number;
  moduleId?: number;
}

export function apiOcppOperationGetStatusNotificationForModuleGet$Plain(http: HttpClient, rootUrl: string, params?: ApiOcppOperationGetStatusNotificationForModuleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusNotificationCommand>> {
  const rb = new RequestBuilder(rootUrl, apiOcppOperationGetStatusNotificationForModuleGet$Plain.PATH, 'get');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.query('connectorId', params.connectorId, {});
    rb.query('moduleId', params.moduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatusNotificationCommand>;
    })
  );
}

apiOcppOperationGetStatusNotificationForModuleGet$Plain.PATH = '/api/OcppOperation/GetStatusNotificationForModule';
